import { color } from '../../../theme/Color';

export default {
  type: 'HorizontalProgressBarList',
  handler: (data) => {
    const values = data?.getPOTopActiveUsersByTime?.data || [];

    if (!values.length) {
      return {
        hasNoData: true,
        items: [],
      };
    }

    const items = values.map((item) => ({
      title: item.userName,
      color: color._6A3452,
      value: item.value,
    }));

    return {
      hasNoData: false,
      items,
    };
  },
};
